<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="my-2">گزارشات</h1>
          <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Fugiat
            placeat inventore minus cum nihil porro dignissimos veniam eum, hic
            doloribus!
          </p>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetAllReports } from "@/libs/Api/Report";
export default {
  mounted() {
    this.getAllReports();
  },
  data() {
    return {
      reportsList: null,
      pageNumber: 1,
      count: 10,
      isLoading: false,
    };
  },
  methods: {
    async getAllReports() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllReports = new GetAllReports(_this);
        getAllReports.setRequestParam({
          count: _this.count,
          pageNumber: _this.pageNumber,
        });
        getAllReports.fetch((response) => {
          if (response.isSuccess) {
            _this.reportsList = response.data.reports;
            console.log(_this.reportsList);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormRadio,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
